<template>
  <section class="admin-content" id="contact-search">
    <Navbar />

    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30" style="margin-top: 35px">
                <div class="card-body">
                  <div class="text-center">
                    <h1><strong>Add Enrollee Form </strong></h1>
                    <p>
                      (All fields marked with
                      <span class="text-danger">*</span> are compulsory)
                    </p>
                  </div>
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-6" v-if="sector == 'formal'">
                        <div class="form-group">
                          <label for="inputCity">Select Category<span class="text-danger">*</span></label>
                          <select class="form-control" required v-model="register.sector">
                            <option value="State Civil Servant">
                              State Civil Servant
                            </option>

                            <option value="LGA Civil Servant">
                              LGA Civil Servant
                            </option>

                            <option value="State Public Servant">
                              State Public Servant (Appointees)
                            </option>
                            <option value="State Pensioners Plan">
                              State Pensioners Plan
                            </option>

                            <option value="Organized Private Sector">
                              Organized Private Sector
                            </option>

                            <option value="T-SHIP">T-SHIP</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Select {{label.place_of_work_label}}

                          <span class="text-danger">*</span>
                        </label>

                        <v-select v-model="register.place_of_work" :options="mdas" label="name"
                          :value="register.place_of_work" @input="getDepts"></v-select>
                      </div>



                      <div class="form-group col-md-6">
                        <label for="inputEmail4">NIN <span class="text-danger">*</span></label>
                        <input type="text" pattern="\d*" maxlength="11" class="form-control"
                          v-model="register.nimc_number" placeholder="NIN" />
                      </div>
                      <div class="form-group col-md-6">
                        <label>Surname <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.lastname"
                          placeholder="Last Name" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" required v-model="register.firstname"
                          placeholder="First Name" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Middle Name</label>
                        <input type="text" class="form-control" v-model="register.middlename"
                          placeholder="Middle Name" />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <p>
                          <label>Date of Birth

                            <span class="text-danger">*</span>
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.dob" />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'T-SHIP'
                        ">
                        <p>
                          <label>Date of First Appointment
                          </label>
                        </p>
                        <input type="date" class="form-control" v-model="register.date_of_entry" />
                      </div>

                      <div class="form-group col-md-12" v-if="register.sector == 'T-SHIP'">
                        <p>
                          <label>Year of Admission:
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.date_of_entry" />
                      </div>


                      <div class="form-group col-md-4" v-if="register.sector == 'T-SHIP'">
                        <p>
                          <label>Year of Graduation:
                          </label>
                        </p>
                        <input type="date" required class="form-control" v-model="register.expiry_date" />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Email</label>
                        <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
                      </div>

                      <div class="form-group col-md-6">
                        <label>Phone Number
                          <span class="text-danger">*</span></label>
                        <input v-phone type="text" pattern="\d*" class="form-control"
                          v-model="register.phone_number" placeholder="Phone Number" />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity">Gender <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.gender">
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'T-SHIP'
                        ">
                        <label for="inputEmail4"> {{label.salary_number_label}} <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="register.salary_number"
                          placeholder="Staff ID" required />
                      </div>
                      <div class="form-group col-md-6" v-if="
                          register.sector ==
                          'T-SHIP'
                        ">
                        <label for="inputEmail4">Matriculation Number</label>
                        <input type="text" class="form-control" v-model="register.salary_number"
                          placeholder="Matric. Number" required />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector !=
                          'T-SHIP'
                        ">
                        <label for="inputEmail4">Grade Level/Step</label>
                        <input type="text" class="form-control" v-model="register.grade_level"
                          placeholder="Grade Level/Step" />
                      </div>

                      <div class="form-group col-md-6" v-if="
                          register.sector ==
                          'T-SHIP'
                        ">
                        <label for="inputEmail4">Class Year</label>
                        <input type="text" class="form-control" v-model="register.grade_level" placeholder="200L" />
                      </div>

                      <div class="form-group col-md-6" v-if="agency.id != '313923'">
                        <label for="inputCity">HMO <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="register.org_id">
                          <option v-for="org in tpas" v-bind:key="org" :value="org.id">
                            {{ org.organization_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Marital Status
                          <span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.marital_status">
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="">NA</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">LGA of Residence<span class="text-danger">*</span></label>
                        <select class="form-control" required v-model="register.localgovt" @change="fetchWards($event)">
                          <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward </label>
                        <select class="form-control" v-model="register.ward">
                          <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Principal Facility for Accessing Health Care
                          <span class="text-danger">*</span>
                        </label>
                        <v-select v-model="register.provider_id" :required="!register.provider_id" :options="providers"
                          label="agency_name"></v-select>
                      </div>





                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address</label>
                        <input type="text" class="form-control" v-model="register.address" placeholder="1234 Main St" />
                      </div>
                    </div>


                    <div class="form-group col-md-12">
                      <label>Photo <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center flex-wrap" style="gap: 10px;">
                        <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                          <i class="fe fe-camera mr-1"></i> Capture Photo
                        </button>
                        <!-- <label class="btn btn-outline-secondary mb-0" style="cursor:pointer;">
                          <i class="fe fe-upload mr-1"></i> Upload Photo
                          <input type="file" accept="image/*" style="display:none;" @change="attachPic" />
                        </label> -->
                        <button v-if="register.user_image && photoOriginal" class="btn btn-outline-secondary btn-sm"
                          type="button" @click="cropPhoto(photoOriginal)">
                          <i class="fe fe-crop"></i> Adjust
                        </button>
                        <button v-if="register.user_image" class="btn btn-outline-danger btn-sm" type="button"
                          @click="removePhoto">
                          <i class="fe fe-x"></i> Remove
                        </button>
                      </div>

                      <div v-if="register.user_image" class="mt-3">
                        <img :src="register.user_image"
                          style="width: 130px; height: 167px; object-fit: cover; border-radius: 6px; border: 2px solid #dee2e6;" />
                        <p class="text-success small mt-1"><i class="fe fe-check-circle mr-1"></i>Photo ready</p>
                      </div>
                    </div>


                    <!-- <div >
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong
                        >
                      </p>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/We hereby declare, on my behalf and on behalf of
                            all persons proposed to be insured that the above
                            statements, answers and/or particulars given by me
                            are true and complete in all respects to the best of
                            my knowledge and that I/We am/ are authorized to
                            propose on behalf of these other persons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I understand that the information provided by me
                            will form the basis of insurance policy, is subject
                            to the Board approved underwriting policy of AGENCY
                            and that the policy will come into force only after
                            full receipt of the premium chargeable.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/ We further declare that I/We will notify in
                            writing any change occurring in the occupation or
                            general health of the life to be insured/ proposer
                            after the proposal has been submitted but before
                            communication of the risk acceptance by AGENCY.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/We declare and consent to AGENCY seeking medical
                            information from any hospital who at any time has
                            attended on the life to be insured/ proposer or from
                            any past or present employer concerning anything
                            which affects the physical and mental health of the
                            life to be assured/proposer and seeking information
                            from any insurance company to which an application
                            for insurance on the life to be assured/ proposer
                            has been made for the purpose of underwriting the
                            proposal and/or claim settlement.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/ We authorize AGENCY to share information
                            pertaining to my proposal including the medical
                            records for the sole purpose of proposal
                            underwriting and/or claims settlement and with any
                            Governmental and/or Regulatory Authority.
                          </label>
                        </div>
                      </div>
                    </div> -->

                    <div class="form-group">
                      <button type="submit" class="btn btn-info btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
            </div>
            <PhotoCropper ref="photoCropper" />
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";

  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import PhotoCropper from "@/components/PhotoCropper.vue";

  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
      PhotoCropper,
    },
    data() {
      return {
        photoOriginal: "",
        agency: agency,
        label: {
          place_of_work_label: agency.id == "930972" ? "SDA" : "MDA",
          salary_number_label: agency.id == "930972" ? "Salary Number" : "Staff ID",

        },
        tpas: "",
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        clients: "",
        providers: "",
        sector: "formal",
        mdas: "",
        depts: "",
        wards: "",
        providers_wards: "",
        state: "",
        OfficerDetails: "",
        current_page: "",
        selected_provider: "",
        selected_provider_dependents: "",
        lga_states: "",
        response: "",
        register: {
          type: "client",
          sector: "formal",
          plan_type: "Family",
          firstname: "",
          lastname: "",
          middlename: "",
          nimc_number: "",
          email: "",
          ministry: "",
          phone_number: "",
          agency_id: "",
          state: "",
          localgovt: "",
          ward: "",
          address: "",
          blood: "",
          gender: "",
          genotype: "",
          dob: "",
          expiry_date: "",
          salary_number: "",
          provider_id: "",
          alternate_provider_id: "",
          finger_print: "",
          place_of_work: "",
          org_id: "",
          grade_level: "",
          date_of_entry: "",
          marital_status: "",
          category_of_vulnerable_group: "",
          user_image: "",
        },
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      //
    },

    methods: {
      submitForm() {
        if (this.register.provider_id == "") {
          this.$toasted.error(`Provider not Selected!`, {
            position: "top-center",
            duration: 3000,
          });
        } else {
          if (confirm("Are you sure you want to submit?")) {
            this.registerUserEmployee();
          }
        }
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${event.target.value}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/${agency.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDepts() {
        this.register.org_id = this.register.place_of_work.hmo_id;
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/${agency.id}`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      registerUserEmployee() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            user_image: this.register.user_image,
            agency_id: agency.id,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname.toUpperCase(),
            lastname: this.register.lastname.toUpperCase(),
            middlename: this.register.middlename.toUpperCase(),
            email: this.register.email,
            phone_number: this.register.phone_number,
            plan_type: this.register.plan_type,
            type: this.register.type,
            sectorType: this.sector,
            provider_id: this.register.provider_id.id,
            alternate_provider_id: this.register.alternate_provider_id.id,
            state: agency.state,
            role: 0,
            password: "euhler",
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            address1: this.register.address,
            genotype: this.register.genotype,
            dob: this.register.dob,
            // expiry_date: this.register.expiry_date,
            date_of_entry: this.register.date_of_entry,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work.name,
            org_id: this.register.org_id,
            // finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            marital_status: this.register.marital_status,
            // category_of_vulnerable_group: this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            // this.getClients();
            this.$toasted.info("Client added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            let user_id = response.data.data.id;
            this.$router.push(`/client/${user_id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            const data = error.response && error.response.data;
            let message;
            if (data && data.errors) {
              this.response = data.errors;
              message = JSON.stringify(data.errors);
            } else if (data && data.message) {
              message = data.message;
            } else {
              message =
                "Could not reach the server. If you attached a photo, try a smaller one, then check your connection and submit again.";
            }
            this.$toasted.error(message, {
              position: "top-center",
              duration: 6000,
            });
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/${agency.id}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProvidersByWards() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(
            `/api/v1/auth/providerAgencies/${agency.id}/${this.register.localgovt}/${this.register.ward}`
          )
          .then((response) => {
            this.providers_wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${agency.id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Base64,
            source: CameraSource.Prompt,
            format: 'jpeg',
          });
          if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
          this.$toasted.success("Photo captured successfully!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Camera error: " + err.message, {
              position: "top-center",
              duration: 4000,
            });
          }
        }
      },

      attachPic(event) {
        const file = event.target.files[0];
        event.target.value = "";
        if (!file) return;
        const reader = new FileReader();
        reader.onload = async (e) => {
          if (!(await this.cropPhoto(e.target.result))) return;
          this.$toasted.success("Photo uploaded successfully!", {
            position: "top-center",
            duration: 3000,
          });
        };
        reader.readAsDataURL(file);
      },
      // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.register.user_image = cropped;
        return true;
      },
      removePhoto() {
        this.register.user_image = "";
        this.photoOriginal = "";
      },

    },
    created() {
      this.fetchLga();
      this.getMDAs();
      this.getProviders();
      this.getTPAs();
    },
  };
</script>